import { Routes } from '@router/routes';

export const SERVICE_LINKS = [
  {
    id: 1,
    name: 'Pages',
    path: Routes.NOT_FOUND,
  },
  {
    id: 2,
    name: 'Elements',
    path: Routes.NOT_FOUND,
  },
  {
    id: 3,
    name: 'FAQs',
    path: Routes.FAQS,
  },
  {
    id: 4,
    name: 'Pricing',
    path: Routes.NOT_FOUND,
  },
  {
    id: 5,
    name: 'Site map',
    path: Routes.NOT_FOUND,
  },
];
